import React from 'react'

export default function GameSelector({history}) {

    const startPlay =()=>{
        history.push('play')
    }
    return (
      <div className='game-selector-container'>
        <h1>Redescubriendo las raíces de los grupos étnicos del Caribe Colombiano</h1>
        <p>Únete a la búsqueda de la Habladora y los símbolos propios de cada uno de los grupos étnicos en nuestro viaje por el Caribe Colombiano. Explora los símbolos en cada una de las obras y descubre un poco más de cada una de las culturas</p>

        <div className='image-play-container'>
          <img id='img-playlist' src='./cultura/playgame.jpeg' alt='juega' />
            <div onClick={startPlay}>
                <img id='play-button' src='./cultura/juega.png' alt='juega' />
            </div>
        </div>
      </div>
    );
}
